import * as React from 'react';
import Loadable from 'react-loadable';

import { RouteInfo } from '@topconagriculture/frontend-utils';
import { Loader } from '@topconagriculture/loader';

const App = Loadable({
  loader: () => import('../App/AppContainer'),
  loading: () => <Loader />,
});

export const authRoutesConfig: RouteInfo[] = [
  {
    path: '/',
    component: App,
  },
];
